module.exports = __webpack_public_path__ + "img/proimg2.8e4089aa.jpg";